// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__NZi15","list":"styles_list__1tg2Q"};